import React, { Component, Suspense } from 'react';
import './App.scss';
import { HashRouter as Router, Route, Redirect, Switch } from "react-router-dom";
import Auth from "./modules/auth/Auth";
import Login from "./scenes/Login";
import { PrivateRoute, PublicPrivateRoute, HomeRoute, MultipleRoute } from './modules/auth/PrivateRoute';
import loadable from '@loadable/component';
// import ResetPassword from './modules/auth/client/components/ResetPassword';
import LoginWithPhone from './scenes/login/LoginWithPhone';
import Welcome from './scenes/Welcome';
import './css';

const SimpleUserHome = loadable(() => import('./scenes/SimpleUserHome'));
const RegisterHandler = loadable(() => import('./scenes/register/RegisterHandler.js'));
const RSuccess = loadable(() => import('./scenes/register/rSuccess/RSuccess.js'));
const Volunteers = loadable(() => import('./scenes/admin/Volunteers.jsx'));
const SAVolunteers = loadable(() => import('./scenes/sadmin/SAVolunteers.jsx'));
const SAAssociationsList = loadable(() => import('./scenes/sadmin/saAssociationsList/SAAssociationsList.js'));

class App extends Component {

    constructor(props) {
        super(props);
        this.state = { isAuth: false };

    }



    async componentDidMount() {
        this.isAuth = await Auth.isAuthenticated();
        this.setState({ isAuth: this.isAuth });
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            document.documentElement.style.setProperty('--vh', window.innerHeight / 100 + 'px');
        }
    }

    render() {

        // return (
        //     <div style={{ color: 'white', textAlign: 'center', fontSize: '2rem', margin: '20vw 5vw' }}>
        //         אנו מצטערים אך זמנית האתר לא יהיה פעיל. נסו שנית מאוחר יותר. תודה ועמכם הסליחה.
        //     </div>
        // );
        const homePages = { LoginWithPhone, RegisterHandler, SimpleUserHome, Volunteers, SAVolunteers };

        return (
            <div className="App">
                <Suspense fallback={<div>Loading...</div>}>
                    <Router>
                        <Switch>
                            <HomeRoute exact path="/" component={LoginWithPhone} comps={homePages} />
                            {/* <Route path="/reset-password" component={ResetPassword} /> */}
                            <Route exact path="/login" render={(props) => <Login {...props} />} />
                            <Route exact path="/welcome" render={(props) => <Welcome {...props} />} />
                            <PublicPrivateRoute exact path="/login-with-phone" compName="LoginWithPhone" component={LoginWithPhone} />
                            <PrivateRoute exact path="/register" compName='RegisterHandler' component={RegisterHandler} />
                            <PrivateRoute exact path='/register-success' compName='RSuccess' component={RSuccess} />
                            {/* <PrivateRoute exact path='/volunteers' compName='Volunteers' component={Volunteers} /> */}
                            <MultipleRoute exact path="/volunteers" comps={{ "Volunteers": Volunteers, "SAVolunteers": SAVolunteers }} />
                            <PrivateRoute exact path='/associations' compName="SAAssociationsList" component={SAAssociationsList} />
                            <Redirect to='/' />
                        </Switch>
                    </Router>
                </Suspense>
            </div>
        );
    }
}

//export default inject('ExampleStore')(observer(App));
export default App;